import {
  DataGroupApiGetDataGroupsSensitivityRequest,
  DataGroupSensitivityResponse,
} from '@ariksa/abac/api';
import { keyBy } from 'lodash';
import { QueryAction } from 'services/types';
import { IQueryState, QueryState } from 'services/utils/QueryState';

export type DataGroupSensitivityStates = Record<
  string,
  IQueryState<DataGroupSensitivityResponse>
>;

export type GetDataGroupsSensitivityAction = QueryAction<
  DataGroupSensitivityResponse[],
  DataGroupApiGetDataGroupsSensitivityRequest
>;

// Builds the bulk sensitivity request for a page of data groups.
export const getDataGroupsSensitivityQuery = (
  dataGroupIds: (string | undefined)[],
): DataGroupApiGetDataGroupsSensitivityRequest => ({
  dataGroupSensitivityRequest: {
    data_group_ids: dataGroupIds.filter((id): id is string => !!id),
  },
});

// Spreads one bulk sensitivity response into per-data-group query states, so
// tables keep reading sensitivity and loading state by data group id while the
// page makes a single request instead of one per data group.
export const updateDataGroupSensitivityStates = (
  states: DataGroupSensitivityStates,
  action: GetDataGroupsSensitivityAction,
) => {
  const dataGroupIds =
    action.payload.q?.dataGroupSensitivityRequest?.data_group_ids ?? [];
  const sensitivityById = keyBy(action.payload.data ?? [], 'data_group_id');

  dataGroupIds.forEach(dataGroupId => {
    states[dataGroupId] = QueryState.next(
      states[dataGroupId] ??
        QueryState.init({} as DataGroupSensitivityResponse),
      {
        ...action,
        payload: { ...action.payload, data: sensitivityById[dataGroupId] },
      } as QueryAction<DataGroupSensitivityResponse>,
    );
  });
};
